module.exports = __webpack_public_path__ + "img/q4-11-active.2272f745.png";